module.exports = __webpack_public_path__ + "assets/img/CreditCard.ef95d6d6.png";